import { render, staticRenderFns } from "./ReportFieldModal.vue?vue&type=template&id=06b0a4f9"
import script from "./ReportFieldModal.vue?vue&type=script&lang=js"
export * from "./ReportFieldModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports